<div class="ctn-dialog">
  <div class="ctn-dialog-header">
    <h4>{{data.title}}</h4>
  </div>

  <div class="ctn-dialog-body">
    <div class="dialog-body-p">

    </div>
  </div>

  <div class="ctn-dialog-footer">
    <div>
      <button mat-flat-button (click)="onNoClick()">Non</button>
      <button mat-button cdkFocusInitial>Oui</button>
    </div>
  </div>
</div>
